import { render, staticRenderFns } from "./UsageTermsHeader.vue?vue&type=template&id=2189c6b9&scoped=true"
import script from "./UsageTermsHeader.vue?vue&type=script&lang=js"
export * from "./UsageTermsHeader.vue?vue&type=script&lang=js"
import style0 from "./UsageTermsHeader.vue?vue&type=style&index=0&id=2189c6b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189c6b9",
  null
  
)

export default component.exports